<template>
  <div class="container">
    <img src="../assets/logo-mastercraft.svg" alt="Mastercraft logo" class="mastercraft-logo">
    <h1>Mastercraft Bamboo Monitor Riser</h1>
    <p>A beautifully handcrafted monitor stand to reduce neck and eye strain.</p>
    <div class="split">
      <button class="btn btn-teal" @click="$emit('showModal')">Back this project</button>
      <button class="btn btn-icon" @click="bookmarkProject">
        <img :src="imgSrc" alt="Bookmark icon" id="bookmark">
        <span id="bookmark-span" :class="{active: this.$store.state.bookmarked}">{{bookmarkStatus}}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Featured',
  data() {
    return {
      imgSrc: require('@/assets/icon-bookmark.svg'),
      bookmarkStatus: 'Bookmark'
    }
  },
  methods: {
    bookmarkProject() {
      this.$store.commit('bookmarked')
      if (this.$store.state.bookmarked) {
        this.imgSrc = require("@/assets/icon-bookmarked.svg")
        this.bookmarkStatus = 'Bookmarked'
      }else {
        this.imgSrc = require("@/assets/icon-bookmark.svg")
        this.bookmarkStatus = 'Bookmark'
      }
    }
  }
}
</script>

<style scoped>

  .container {
    width: 90%;
    background-color: var(--clr-neutral-100);
    border-radius: 10px;
    padding: 2rem 1rem;
    margin-inline: auto;
    margin-top: -3.5rem;
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
  }

  .mastercraft-logo {
    width: 60px;
    height: 60px;
    margin-inline: auto;
    margin-top: -4rem;
    margin-bottom: 1rem;
  }

  h1 {
    font-size: var(--fs-h1);
  }

  .split {
    flex-direction: row;
    justify-content: space-evenly;
  }

  @media (min-width: 1440px) {
    .container {
      width: 50%;
    }

    .split {
      justify-content: space-between;
      padding-inline: 3rem;
    }

    #bookmark-span {
      display: flex;
      padding: 0.5rem 1.5rem 0.5rem 1rem;
      color: var(--clr-neutral-500);
      align-items: center;
      justify-content: center;
    }

    #bookmark-span.active {
      color: var(--clr-primary);
    }
  }
</style>